export enum SwithTypesEnum {
    primary = 'primary',
    white = 'white'
}
